import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "./context/UserContext.jsx";
import { useInactivityTimer } from "./hooks/userInactivityTimer";

import Router from "./routes/index.js";

function AppContent() {
  const navigate = useNavigate();

  useInactivityTimer(() => {
    localStorage.removeItem("userId");
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("pkce_verifier");
    localStorage.removeItem("leadId");
    localStorage.removeItem("email");
    navigate("/login");
  });

  return (
    <>
      <Router />
      <ToastContainer />
    </>
  );
}

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

export default App;
